export default {
  topMenu: {
    openSettings: 'Otevřít nastavení',
    showAbout: 'Zobrazit obecné informace',
    about: 'O ORS',
    pinSidebar: 'Připnout boční panel',
    settingsTooltip: 'Pokud chcete upravit nastavení aplikace, klikněte sem'
  }
}
